import type { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { AppRoutes } from '@/constants/routes';
import {
    useFeatureFlagsState,
    type FeatureFlags,
} from '@/hooks/useFeatureFlags';

interface FeatureGuardProps {
    children: JSX.Element;
    flag: keyof FeatureFlags;
}

export function FeatureGuard({
    children,
    flag,
}: FeatureGuardProps): JSX.Element | null {
    const { flags, isLoading } = useFeatureFlagsState();

    if (isLoading) {
        return null;
    }

    if (!flags[flag]) {
        return <Navigate to={AppRoutes.HOME} replace />;
    }

    return children;
}
